<template>
  <!-- password change confirmation. Link located on the login screen -->

  <div class="container-fluid py-5">
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-4 mx-auto">
        <div class="card card-signin my-5 card-opacity">
          <div class="card-body">
            <img
              class="mx-auto rounded mx-auto d-block logo-image"
              alt="logoImage"
              :src="logoImage"
            />
            <h5 class="card-title text-center text-join">Tudo pronto!</h5>
            <div style="display: flex; justify-content: center">
              <p class="">Sua senha foi redefinida com sucesso</p>
            </div>

            <form class="form-signin" autocomplete="off">
              <div class="access-center">
                <button
                  class="btn btn-lg access-confirmation"
                  id="sendConfirmationPasswordComponent"
                  type="submit"
                  @click="$router.push(`/newPassword`)"
                >
                  Fazer login
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "ConfirmationPassword",
  data() {
    return {
      logoImage: "",
      group: localStorage.group,
    };
  },
  mounted() {
    this.token = this.$route.query.token;

    axios
      .get(`${process.env.API_PBM}/group/${this.group}`)
      .then((response) => {
        let background = response.data.data.background;
        let logo = response.data.data.logo;
        if (background != null) {
          document.body.className = "background-login";
          document.body.style.backgroundImage = `url("${background}")`;
        }
        if (logo != null) {
          this.logoImage = logo;
        }
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* body {
  background-image: url("https://portaldeboletos.com.br/images/background/GERDAU20180607154650000000.jpg");
  background-repeat: repeat-x;
} */
</style>
<style scoped>
.text-join {
  color: rgb(100, 95, 95);
  font-size: 20px;
  margin-top: 70px;
}

.text-align-center {
  margin-top: 5px;
  color: rgb(100, 95, 95);
  font-size: 13px;
  text-align: center;
}

.card-opacity {
  background: rgba(255, 255, 255, 0.9);
  border: none;
}

.access-confirmation {
  background-color: #b0191a;
  color: #fff;
  width: 35%;
  margin-top: 20px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
  margin-bottom: 70px;
  text-decoration: none !important;
}
.access-center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/components/forgotPassword/ConfirmationPassword.vue